module.exports = __webpack_public_path__ + "static/media/dwt-03.0e949087.jpg";